<template>
  <v-alert :type="data.type" :title="data.title"  :density="'compact'" :variant="'flat'"
      :border="'start'" :elevation="3" min-width="15em" max-width="20em" :class="`mb-${alertMarginBottom}`">
      <template v-slot:text>
      <p v-html="txt_parsed">
      </p>
      <p class="mt-4 d-flex justify-end" v-if="data.dismissByUser" @click="toastsStore.deleteByUUID(data.uuid)">
        <v-btn color="white" variant="outlined">
            Ok
        </v-btn>
      </p>
      </template>
  </v-alert>
  <v-progress-linear v-if="data.showUICountdown" :color="data.type" height="6" v-model="remainingDurationPercentage"
      class="mb-2" striped
      >
  </v-progress-linear>
</template>

<script setup>

import { ref, computed, onBeforeMount } from "vue";
import { useToastsStore } from "@/store/toasts";

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const toastsStore = useToastsStore()

const txt_parsed = computed(() => {
  return props.data.text.replace(/(?:\r\n|\r|\n)/g, '<br>')
})

const alertMarginBottom = ref(2)

const remainingDurationPercentage = ref(100)


onBeforeMount(() => {


  let remainingDuration = props.data.duration
  const intervalDuration = 50

  
  if (props.data.showUICountdown) {
    alertMarginBottom.value = 0

    const intervalID = setInterval(() => {

      
      remainingDuration = remainingDuration - intervalDuration
      remainingDurationPercentage.value = Math.floor((remainingDuration / props.data.duration) * 100)

      // console.log(remainingDuration)
      // console.log(remainingDurationPercentage.value)


      if (remainingDuration <= 0) {
        clearInterval(intervalID)
      }

    }, intervalDuration)
  }
})

</script>
<style scoped>
.v-progress-linear{
  background-color: #0002;
  margin-top: 2px;
}
/* .v-alert{
  pointer-events: none;
}

.v-alert .v-btn{
  pointer-events: auto;
} */
</style>
